// extracted by mini-css-extract-plugin
export default {"corpSubCard":"v73a47JfXHLHNvgCchHL","corpSubCardHeader":"Yd3y437B2Yg59nZbLEKd","corpSubCardSubtitle":"EhYQP8cwNTiBJxGVteW3","topBarCorp":"I3n2fA67nnMTGcqHy6Sw"};